import React from 'react';
import { connect } from 'react-redux';
import { Col, Row, Badge } from 'react-bootstrap-5';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CriteriaDecorator from '../../helpers/criteria_decorator';
import { setFilterAttribute } from 'bundles/connect/components/store/actions/criteria';
import { faCircleXmark } from '@fortawesome/pro-regular-svg-icons';

type FilterBadgeProps = {
  filter: {
    keys?: string[];
    label: string;
  };
  removeFilter: (filter: { keys?: string[]; label: string }) => void;
};

function FilterBadge({ filter, removeFilter }: FilterBadgeProps) {
  const removeable = !!filter.keys;
  if (filter.keys && filter.keys.includes('locationAttributes')) return null;

  return (
    <Col key={filter.label} xs="auto">
      <Badge
        bg=""
        className={`badge-primary badge-accent ${removeable ? 'clickable' : ''}`}
        onClick={filter.keys ? () => removeFilter(filter) : undefined}
      >
        {filter.label}
        {removeable && <FontAwesomeIcon className="ms-2" icon={faCircleXmark} size="lg" />}
      </Badge>
    </Col>
  );
}

type EmptyStateBadgesProps = {
  filterSummary: {
    keys: string[];
    label: string;
  }[];
  setFilterAttribute: (key: string, value: any) => void;
};

function EmptyStateBadges({ filterSummary, setFilterAttribute }: EmptyStateBadgesProps) {
  const removeFilter = (filter) => {
    if (!filter.keys) return;

    filter.keys.forEach(key => setFilterAttribute(key, undefined));
  };

  return (
    <Row className="g-2 justify-content-center">
      {filterSummary.map(filter => <FilterBadge filter={filter} key={filter.label} removeFilter={removeFilter}/>)}
    </Row>
  );
}

const mapStateToProps = ({ criteria, ui: { offMarketSearch } }) => ({
  filterSummary: new CriteriaDecorator(criteria, offMarketSearch).filterSummary()
});
const mapDispatchToProps = { setFilterAttribute };

export default connect(mapStateToProps, mapDispatchToProps)(EmptyStateBadges);
